import { ModalStateMessage } from '@/store/root/root-store.model'
import { store } from '@/store/store'
import i18n from '@/lang/i18n'
import { AxiosError } from 'axios'
import Vue from 'vue'
import { ConfirmationModalCheckableResponse } from '@/shared/models/common.models'

export class ModalUtils {
    private static _showModal(message: string, icon?: string, state?: string, hideAutomatically?: boolean): void {
        const modalState: ModalStateMessage = {
            message,
            icon,
            state,
            hideAutomatically
        }
        store.commit('updateModalStateMessage', modalState)
    }

    static showInfoModal(message: string): void {
        ModalUtils._showModal(message, 'fal fa-info', 'vt-modal vt-modal--info', false)
    }
    static showWarningModal(message: string): void {
        ModalUtils._showModal(message, 'fal fa-exclamation', 'vt-modal vt-modal--warning', false)
    }
    static showSuccessModal(message: string = i18n.tc('component.modalShowSuccess.title')): void {
        ModalUtils._showModal(message, 'fal fa-check', 'vt-modal vt-modal--success', true)
    }
    static showErrorModal(message: string = i18n.tc('component.modalError.title')): void {
        ModalUtils._showModal(message, 'fal fa-times', 'vt-modal vt-modal--error', false)
    }

    static showErrorModalFromErrorResponse(error: AxiosError, alternativeMessage?: string): void {
        const message =
            error?.response?.data?.messageTranslated
                ? error.response.data.message
                : alternativeMessage
        ModalUtils.showErrorModal(message)
    }

    static showConfirmationModal(
        question: string = '',
        okTitle?: string,
        cancelTitle?: string,
        qaId?: number,
        cancelOnHide?: boolean
    ): Promise<boolean> {
        return new Promise((resolve) => {
            Vue.prototype.$eventHub.$emit('showConfirmationModal', { question, okTitle, cancelTitle, qaId, cancelOnHide })
            Vue.prototype.$eventHub.$on('confirmationModalResponse', (response: boolean) => {
                Vue.prototype.$eventHub.$off('confirmationModalResponse')
                resolve(response)
            })
        })
    }

    static showConfirmationModalCheckable(
        params: {
            question?: string,
            okTitle?: string,
            cancelTitle?: string,
            qaId?: number,
            cancelOnHide?: boolean,
            checkable?: boolean,
            dontShowAgainCheckableText?: string
        }): Promise<ConfirmationModalCheckableResponse> {
        return new Promise((resolve) => {
            Vue.prototype.$eventHub.$emit('showConfirmationModalCheckable', {
                question: params.question,
                okTitle: params.okTitle,
                cancelTitle: params.cancelTitle,
                qaId: params.qaId,
                cancelOnHide: params.cancelOnHide,
                checkable: params.checkable,
                dontShowAgainCheckableText: params.dontShowAgainCheckableText })
            Vue.prototype.$eventHub.$on('confirmationModalResponseCheckable', (response: ConfirmationModalCheckableResponse) => {
                Vue.prototype.$eventHub.$off('confirmationModalResponseCheckable')
                resolve(response)
            })
        })
    }
}
